module.exports = __webpack_public_path__ + "src/assets/textures_low/popups/header_short.png";